import { GET_SEARCH } from '@/domain/navigation/features/search/graphql/queries';
import {
  Navigation_SearchQuery,
  Navigation_SearchQueryVariables,
} from '@/gql/graphql';
import { useQuery } from '@apollo/client/react';
import {
  MitarbeiterResult,
  StandortResult,
} from '@/domain/navigation/features/search/types/resultItem';

export default function useSearch(query: string): {
  loading: boolean;
  error: Error | undefined;
  standortResults: (StandortResult | MitarbeiterResult)[];
} {
  const { data, loading, error } = useQuery<
    Navigation_SearchQuery,
    Navigation_SearchQueryVariables
  >(GET_SEARCH, {
    variables: { query },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  type SearchResultItem = Navigation_SearchQuery['search'][number];

  // Mappe die Daten auf StandortResultItems
  const standortResults: StandortResult[] = (data?.search || [])
    .filter(
      (
        item,
      ): item is Extract<
        SearchResultItem,
        { __typename?: 'navigation_Standort' }
      > => item.__typename === 'navigation_Standort',
    )
    .map(
      (item) =>
        new StandortResult({
          id: item.id,
          name: item.name,
          standortId: item.id,
        }),
    );

  const mitarbeiterResults: MitarbeiterResult[] = (data?.search || [])
    .filter(
      (
        item,
      ): item is Extract<
        SearchResultItem,
        { __typename?: 'navigation_Mitarbeiter' }
      > => item.__typename === 'navigation_Mitarbeiter',
    )
    .map(
      (item) =>
        new MitarbeiterResult({
          id: item.id,
          vorname: item.vorname,
          nachname: item.nachname,
          standort: item.standort,
          bildUrl: item.bildUrl ?? null,
          type: item.type,
          extern: item.extern,
          personalnummer: item.personalnummer ?? null,
        }),
    );

  return {
    loading,
    error,
    standortResults: [...standortResults, ...mitarbeiterResults],
  };
}
